<template>
  <div class="wrapper">
    <div class="button" v-show="level == 0">
      <Button type="primary" v-show="!isEdit" @click="edit">修改</Button>
      <Button type="text" v-show="isEdit" @click="cancel">取消</Button>
      <Button type="primary" v-show="isEdit" @click="submit">保存</Button>
    </div>
    <Form :model="form" :rules="validation" ref="form" :label-width="136" class="form"  label-position="left" :disabled="!isEdit" v-if="!isLoading">
      <Row :gutter="50">
        <Col :span="12">
          <FormItem :label="`${msg.university_id}：`" prop="university_id">
            <Select
              ref="select"
              v-model="form.university_id"
              filterable
              remote
              :remote-method="selfOrgList"
              :placeholder="`请输入${msg.university_id}`"
              :loading="isSelectLoading"
              @on-query-change="changeQuery"
            >
              <Option v-for="option in options" :value="option.university_id" :key="option.university_id" :label="option.name">{{option.name}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label="`${msg.department}：`" prop="department">
            <Input :placeholder="`例：图书馆阅读推广部`" v-model="form.department" clearable/>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="50">
        <Col :span="12">
          <FormItem :label="`${msg.name}：`" prop="name">
            <Input :placeholder="`请输入${msg.name}`" :maxlength="10" v-model="form.name" clearable/>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label="`${msg.mobile}：`" prop="mobile">
            <Input :placeholder="`请输入${msg.mobile}`" v-model="form.mobile" disabled/>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="50">
        <Col :span="12">
          <FormItem :label="`${msg.position}：`" prop="position">
            <Input :placeholder="`请输入${msg.position}`" v-model="form.position" clearable/>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label="`${msg.phone}：`" prop="telephone">
            <Input :placeholder="`请输入${msg.phone} ${phoneText}`" v-model="form.telephone" clearable/>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="50">
        <Col :span="12">
          <FormItem :label="`${msg.address}：`" prop="address">
            <Input :placeholder="`请准确填写收件地址、收件人姓名、电话号码，用于寄送证书等资料。`" v-model="form.address" clearable  type="textarea" :autosize="{ minRows: 2, maxRows: 3 }"/>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label="`${msg.email}：`" prop="email">
            <Input :placeholder="`请准确填写，用于接收技术平台链接等`" v-model="form.email" clearable/>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
import { handleResAuthor, getCookie } from "@/js/public";
import { getOrgList, getUserInfo, editUserInfo, getSuperUser } from "@/api/getApi";
import { FormItem, Form, Button, Input, Select, Option, Row, Col } from "view-design"
export default {
  name: 'userInfo',
  components: {
    FormItem, Form, Button, Input, Select, Option, Row, Col
  },
  data () {
    return {
      modalTitle: '编辑报名信息',
      form: {
        name: '',
        lib_type: '',
        university_id: '',
        phone: '',
        mobile: '',
        department: '',
        position: '',
        code: '',
        org_name: ''
      },
      phoneText: '(区号—电话号码)',
      msg: {
        university_id: '机构名称',
        name: '管理员姓名',
        mobile: '管理员手机号',
        code: '验证码',
        department: '所属部门',
        position: '职务',
        phone: '座机号码',
        address: '收件地址',
        email: '电子邮箱'
      },
      validation: {
        name: [{ required: true, message: `请输入管理员姓名`, trigger: 'blur' }],
        lib_type: [{ type: 'number', required: true, message: `请选择`, trigger: 'blur' }],
        university_id: [{ type: 'number', required: true, message: `请输入机构名称`, trigger: 'blur' }],
        telephone: [{ required: true, message: `请输入座机号码`, trigger: 'blur' },
          /* eslint-disable-next-line */
          { pattern: /^0?\d{2,3}\-\d{7,8}$/, message: `请输入正确的座机号码`, trigger: 'blur' }],
        mobile: [{ required: true, message: `请输入管理员手机号`, trigger: 'blur' },
          { pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: `请输入正确的管理员手机号`, trigger: 'blur' }],
        department: [{ required: true, message: `请输入所属部门`, trigger: 'blur' }],
        position: [{ required: true, message: `请输入职务`, trigger: 'blur' }],
        code: [{ required: true, message: `请输入验证码`, trigger: 'blur' }],
        email: [{ required: true, message: `请输入电子邮箱`, trigger: 'blur' },
          { pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, message: `请输入正确的电子邮箱`, trigger: 'blur' }],
        address: [{ required: true, message: `请输入收件地址`, trigger: 'blur' }]
      },
      orgData: [],
      options: [],
      isSelectLoading: false,
      isEdit: false,
      isLoading: true
    }
  },
  methods: {
    submit () {
      const params = {
        university_id: this.form.university_id,
        name: this.form.name,
        telephone: this.form.telephone,
        position: this.form.position,
        department: this.form.department,
        email: this.form.email,
        address: this.form.address
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          const res = await editUserInfo(params)
          if (res.code !== 200) {
            this.$Message.error(res.message)
            return
          }
          this.$Message.success(`成功修改报名信息`)
          this.getInfo()
          this.isEdit = false
        }
      })
    },
    selfOrgList (str) {
      this.isSelectLoading = true
      this.options = this.orgData.filter((val) => {
        // eslint-disable-next-line eqeqeq
        if (val.name.includes(str) || val.university_id == Number(str)) {
          return val
        }
      })
      this.isSelectLoading = false
    },
    async getSchoolList () {
      try {
        const res = await getOrgList()
        if (res.code !== 200) {
          this.$Message.error(res.message)
          return
        }
        this.orgData = res.data || []
        this.selfOrgList(this.form.university_id)
      } catch (e) {
        this.$Message.error(e)
      }
    },
    async getInfo () {
      const res = this.level == 0 ? await getUserInfo() : await getSuperUser(this.$route.query.id)
      handleResAuthor(res.code, res.message)
      this.form = this.level == 0 ? Object.assign(res.data) : (res.data && res.data.length ? res.data[0] : {})
      this.isLoading = false
    },
    edit () {
      this.isEdit = true
    },
    cancel () {
      this.isEdit = false
      this.$refs.form.resetFields()
      this.getInfo()
    },
    changeQuery (query) {
      if (!query) {
        this.form.university_id = ''
        this.options = []
      }
    }
  },
  async created () {
    await this.getSchoolList()
    await this.getInfo()
  },
  computed: {
    level () {
      return getCookie('level')
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 30px;
}
.form {
  width: 85rem;
}
.button {
  margin-bottom: 20px;
}
::v-deep .ivu-form-item-label {
  font-size: 1.6rem;
}
</style>
